import http from "./HTTP";

export default {
  login(username, password) {
    return http().post("/api-token-auth/", { username, password });
  },
  getCurrentUser() {
    return http().get("/users/current-user/");
  }
};
